import * as React from "react";
import { page } from "../../components/Auth/Page";

export const NextStepsPage = page(React.lazy(() => import("./containers/NextStepsPage")));
